import { render } from "./viewIcon.svg?vue&type=template&id=4e5a7c7d"
const script = {}
script.render = render

export default script